import { render, staticRenderFns } from "./AffiliateMembers.vue?vue&type=template&id=4730762c"
import script from "./AffiliateMembers.vue?vue&type=script&lang=ts"
export * from "./AffiliateMembers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports